import AuthLogout from './Logout';

export default AuthLogout;
